import { Component } from '@angular/core';

@Component({
  selector: 'app-item-title',
  templateUrl: './item-title.component.html',
  styleUrls: ['./item-title.component.scss'],
})
export class ItemTitleComponent {

  constructor() { }


}
